// extracted by mini-css-extract-plugin
export default {"wrapper":"dateExpiredChecker_wrapper__+y4QT","expireTooltip":"dateExpiredChecker_expireTooltip__wb2lL"};